(() => {
  const estimate = 'For eligible U.S. delivery addresses: Estimated delivery: approximately 25 business days from order placement, including production and shipping.';
  const replacements = new Map([
    ['Production: approximately 10-15 business days. Estimated U.S. transit: 15-25 business days after production.', estimate],
    ['Production: approximately 10-15 business days', 'Approximately 25 business days from order placement, including production and shipping, for eligible U.S. delivery addresses.'],
    ['10-15 business days', 'Approx. 25 business days'],
    ['Production, then shipping', 'Eligible U.S. delivery, including production and shipping'],
    ['10-15 business days production', 'Estimated U.S. delivery: approx. 25 business days'],
    ['Shipping time is additional', 'From order placement; includes production and shipping'],
  ]);
  const reconcile = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script,style,textarea,input')) continue;
      const replacement = replacements.get(node.textContent.trim());
      if (!replacement) continue;
      const old = node.textContent;
      node.textContent = old.replace(old.trim(), replacement);
      if (parent.tagName === 'DD') {
        const label = parent.previousElementSibling;
        if (label?.tagName === 'DT' && label.textContent.trim() === 'Production') label.textContent = 'Estimated U.S. delivery';
      }
    }
  };
  const init = () => {
    reconcile();
    new MutationObserver(reconcile).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();